export var ADD_TO_BAG = 'addToBag';
export var DEFAULT_EXPIRE_TIME_1HR = 3600;
export var NATIONAL_CURRENCY = 'BRL';
export var ONE_SEC_IN_MS = 1000;
export var ONE_TOUCH = 'oneTouch';
export var PICKUP_STORE = 'pickupStore';
export var STORAGE_CHECKER_ERROR_MSG = "\nAn error ocurred while handling local storage and\nyour action was not concluded, please check your browser\nsupport and make sure you are not running SSR\n";
export var USE_STORAGE_KEY_ERROR_MSG = 'Invalid key type. To useStorage work properly, the storageKey must be a string. Received type:';
export var VOLTAGE = 'voltage';